// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2j0Rh","fileBtn":"File_fileBtn__1adq_","closeBtn":"File_closeBtn__3a1C1","fileSelected":"File_fileSelected__7PE8a","disabled":"File_disabled__1kmRk"};